<template>
  <div class="page-view">
    <div class="header">
      <Header></Header>
    </div>
    <div class="main">
      <v-sidebar
        :key="siderKey"
        ref="sidebar"
        :isdisplay="display"
        :sider-bar-width="siderBarWidth"
        :items="routes"
        @operationLoading="operationLoading"
      />
      <div class="el-main">
        <div>
          <transition name="fade-transform" mode="out-in">
            <NoPermissionPage v-if="hasRoutePermission === false" />
            <router-view  v-if="hasRoutePermission === true"  :key="key"/>
          </transition>
        </div>

        <el-dialog
          title="版本更新提示"
          :visible.sync="versionUpdateVisible"
          width="30%"
          :show-close="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          center
        >
          <div v-if="versionContent.update" class="flex">
            <div style="width: 64px">[ 更新 ]</div>
            <div v-html="versionContent.update"></div>
          </div>
          <div v-if="versionContent.optimization" class="flex">
            <div style="width: 64px">[ 优化 ]</div>
            <div v-html="versionContent.optimization"></div>
          </div>
          <div v-if="versionContent.repair" class="flex">
            <div style="width: 64px">[ 修复 ]</div>
            <div v-html="versionContent.repair"></div>
          </div>
          <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleOk">确 定</el-button>
          </span>
        </el-dialog>

      </div>
      <div class="page-foot">
        <img src="@/assets/rzlogo.png" />
        <span class="text">长沙睿展数据科技有限公司</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/header/Header'
import vSidebar from './Sidebar.vue'
import NoPermissionPage from './common/NoPermissionPage.vue'
import { checkUserVersionUpdateStatus, changeUserVersionUpdateStatus } from '@/api/login'

export default {
  components: {
    vSidebar,
    Header,
    NoPermissionPage
  },
  data() {
    return {
      contentLoading: false,
      siderKey: 0,
      arrowDown: 'el-icon-arrow-down',
      buttonStyle: '180px',
      siderBarWidth: '180px',
      contentWidth: '180px',
      display: 'block',
      username: '',
      ifIframe: false,
      showSidebar: true,
      inQiankun: true,
      hasRoutePermission: null,
      loading: true,
      versionUpdateVisible: false,
      versionContent: {
        update: null,
        optimization: null,
        repair: null,
        id: null
      }
    }
  },
  watch: {
    // 判断当前菜单是否有权限
    $route: {
      immediate: true,
      handler(route) {
        sessionStorage.setItem('templateFlag', 1)
        this.hasRoutePermission = false
        this.checkPermission(this.$router.options.routes, route.path, route)
      }
    }
  },

  computed: {
    ...mapGetters(['routes']),
    key() {
      return this.$route.path
    }
  },
  mounted() {
     this.checkUserVersionUpdateStatus()
    // this.checkUserServerExpirationTime()
  },
  methods: {
    // 判断当前菜单是否有权限
    checkPermission(routes, path, route) {
      if (route.meta && route.meta.alwaysShow) {
        this.hasRoutePermission = true
        return
      }
      if (
        [
          '/user/profile',
          '/UDIManage/template/UdiTemplateDesign',
          '/UDIManage/changeRecord',
          '/UDIManage/autocode'
        ].includes(path)
      ) {
        this.hasRoutePermission = true
        return
      }
      if (routes === null || !Array.isArray(routes) || routes.length === 0) return
      routes.forEach((cur) => {
        if (cur.path === path) {
          this.hasRoutePermission = !!cur.permissionShow
        } else {
          this.checkPermission(cur.children, path,route)
        }
      })
    },

    operationLoading(flag) {
      this.contentLoading = flag
    },
    /**
     * @description: 控制版本更新弹窗是否展示
     * @return {*}
     * @param {*} flag
     */
    open(flag) {
      this.versionUpdateVisible = flag
    },
    /**
     * @description: 关闭版本更新弹窗，更改用户已知晓版本更新内容状态
     * @return {*}
     */
    handleOk() {
      const that = this
      changeUserVersionUpdateStatus(this.versionContent.id).then(() => {
        that.open(false)
      })
    },
    /**
     * @description: 检查用户已知晓版本更新内容状态
     * @return {*}
     */
    checkUserVersionUpdateStatus() {
      const that = this
      checkUserVersionUpdateStatus().then((res) => {
        if (res.data && res.data.id) {
          const { update, optimization = '', repair = '' } = JSON.parse(res.data.contentInfo)
          that.versionContent = {
            update: this.stringFormat(update),
            optimization: this.stringFormat(optimization),
            repair: this.stringFormat(repair),
            id: res.data.id
          }
          that.open(true)
        }
      })
    },
    /**
     * @description: 将 换行符替换成html能识别的代码
     * @return {*}
     */
    stringFormat(string) {
      return string ? string.replace(/\n/g, '<br/>') : null
    },
    mGetDate(year, month) {
      const date = new Date(year, month, 0)
      return date.getDate()
    },
    /**
     * @description: 判断是否服务到期
     * @return {*}
     */
    checkUserServerExpirationTime() {
      const { serviceName, deprecateTime } = this.$store.state.user.serverInfo
      const { vendorCode, vendorMsg } = this.$store.state.user.userInfo
      const now = new Date().valueOf()
      const deprecateTimeValue = new Date(deprecateTime).valueOf()
      if (serviceName) {
        let message = `您的UDI服务将于${deprecateTime}到期，为了不影响您的正常使用请及时联系售后续订。`
        if (deprecateTimeValue < now) {
          message = `您的UDI服务已于${deprecateTime}到期，为了不影响您的正常使用请及时联系售后续订。`
        }
        this.$notify({
          title: '提示',
          message,
          duration: 0,
          onClose: () => {
            this.$store.commit('SET_SERVER_TIME_STATUS', true)
          }
        })
      }
      if (typeof vendorCode === 'boolean') {
        this.$notify({
          title: '提示',
          message: vendorMsg,
          duration: 0,
          onClose: () => {}
        })
      }
    }
  }
}
</script>

<style>
.page-view {
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.main {
  height: 100%;
  overflow: auto;
  display: flex;
  background-color: #f0f2f5;
}

.sidebar {
  position: static !important;
}
</style>
